import { render, staticRenderFns } from "./recDialog.vue?vue&type=template&id=299c27ae&"
import script from "./recDialog.vue?vue&type=script&lang=js&"
export * from "./recDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports